import axios from 'axios';

import { ISpesificEltCode } from '@modules/admin/Tools/LenderUtility/interfaces';
import { SERVICES } 	      from '@shared/constants/apiConfig';
import { Notistack }	      from '@shared/components/Notistack/Notistack';
import { getError }         from '@shared/utils/helpers';

export const createEltCodeRequest = async(id: string, values: ISpesificEltCode, closeModal: () => void) => {
  try {
    await axios.post(`/${SERVICES.LENDER}/lenders/${id}/eltcode`, values);
    Notistack.successMessage('ELT Code - Created Successfully');
    closeModal();
  } catch (error) {
		Notistack.generalError(getError(error));
  }
};

export const updateEltCodeRequest = async(id: string, values: ISpesificEltCode, closeModal: () => void) => {
  try {
    await axios.patch(`/${SERVICES.LENDER}/lenders/${id}/eltcode`, values);
    Notistack.successMessage('ELT Code - Updated Successfully');
    closeModal();
  } catch (error) {
    Notistack.generalError(getError(error));
  }
};

export const deleteEltCodeRequest = async(lenderId: string, state: string) => {
  try {
    const URL = `/${SERVICES.LENDER}/lenders/${lenderId}/eltcode`;
    const finalURL = state !== null && state !== undefined  ? `${URL }?state=${state}`  : URL ;
    await axios.delete(finalURL);
    Notistack.successMessage('ELT Code - Deleted Successfully');
  } catch (error) {
		Notistack.generalError(getError(error));
  }
};
